import React from 'react';
import { Card } from './ui/card';
import { ShoppingCart, Package, Truck, CreditCard, Clock, Shield } from 'lucide-react';

export const OnlineStore = () => {
  return (
    <section id="loja" className="py-20 bg-gradient-to-br from-red-600 via-red-700 to-red-800 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v6h6V4z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main CTA */}
        <div className="text-center mb-16">
          <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
            <p className="text-white font-semibold flex items-center gap-2">
              <ShoppingCart size={20} />
              Compre Online 24/7
            </p>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Acesse Nossa Loja Virtual
          </h2>
          <p className="text-xl text-red-100 max-w-3xl mx-auto mb-8">
            Navegue pelo catálogo completo, consulte disponibilidade em tempo real e faça seus pedidos com praticidade
          </p>
          
          <a
            href="https://www.vhsys.net/ssadistribuidora"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-white text-red-600 px-12 py-6 text-xl font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105 shadow-2xl"
          >
            <ShoppingCart className="mr-3" size={28} />
            Acessar Loja Virtual
            <svg className="ml-3 w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
          <Card className="bg-white/10 backdrop-blur-md border-white/20 p-6 hover:bg-white/20 transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 bg-white rounded-lg mb-4">
              <Package className="text-red-600" size={28} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Catálogo Completo
            </h3>
            <p className="text-red-100">
              +1000 produtos com especificações técnicas detalhadas
            </p>
          </Card>

          <Card className="bg-white/10 backdrop-blur-md border-white/20 p-6 hover:bg-white/20 transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 bg-white rounded-lg mb-4">
              <Clock className="text-red-600" size={28} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Disponibilidade em Tempo Real
            </h3>
            <p className="text-red-100">
              Consulte estoque atualizado e prazos de entrega
            </p>
          </Card>

          <Card className="bg-white/10 backdrop-blur-md border-white/20 p-6 hover:bg-white/20 transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 bg-white rounded-lg mb-4">
              <CreditCard className="text-red-600" size={28} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Pagamento Facilitado
            </h3>
            <p className="text-red-100">
              Diversas formas de pagamento para sua comodidade
            </p>
          </Card>

          <Card className="bg-white/10 backdrop-blur-md border-white/20 p-6 hover:bg-white/20 transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 bg-white rounded-lg mb-4">
              <Truck className="text-red-600" size={28} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Entrega Rápida
            </h3>
            <p className="text-red-100">
              Logística eficiente para todo o Brasil
            </p>
          </Card>

          <Card className="bg-white/10 backdrop-blur-md border-white/20 p-6 hover:bg-white/20 transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 bg-white rounded-lg mb-4">
              <Shield className="text-red-600" size={28} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Compra Segura
            </h3>
            <p className="text-red-100">
              Ambiente protegido com certificado SSL
            </p>
          </Card>

          <Card className="bg-white/10 backdrop-blur-md border-white/20 p-6 hover:bg-white/20 transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 bg-white rounded-lg mb-4">
              <svg className="text-red-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" width="28" height="28">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-white mb-2">
              Atendimento Especializado
            </h3>
            <p className="text-red-100">
              Suporte técnico para auxiliar na escolha
            </p>
          </Card>
        </div>

        {/* Secondary CTA */}
        <div className="text-center mt-12">
          <p className="text-red-100 mb-4 text-lg">
            Dúvidas sobre algum produto? Nossa equipe está pronta para ajudar!
          </p>
          <a
            href="#contato"
            className="inline-flex items-center text-white hover:text-red-100 font-semibold transition-colors underline"
          >
            Entre em contato conosco
            <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};
